module.exports = __webpack_public_path__ + "static/media/confetti-outline.5460d645.gif";